function NRSwapIcon({ height = '24', width = '24', color = 'currentColor', handleClick }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="nr-swap-icon"
      onClick={handleClick}
    >
      <path
        d="M21 17L16 22L11 17L12.4 15.575L15 18.175L15 3H17V18.175L19.6 15.575L21 17ZM13 7L11.6 8.425L9 5.825V21H7L7 5.825L4.4 8.425L3 7L8 2L13 7Z"
        fill={color}
      />
    </svg>
  );
}

export default NRSwapIcon;
